(function($) {

	'use strict';

	var init = function() {
		initNewsbar();
		subMenuWidth();
		initMobileMenu();
		initQuickLinks();
	};

	var initQuickLinks = function(){
        
		$('a[href="#quick-nav"]').on('click', function(e){
			if($(e.currentTarget).hasClass('quick-links__toggle')){
				e.preventDefault();
				$('.quick-links').toggleClass('open');
                $('#contact_bloc, .pageBanner .ligue-calendar').toggleClass('hide');
			} else if(!$('.quick-links').hasClass('open')){
				$('.quick-links').addClass('open');
                $('#contact_bloc, .pageBanner .ligue-calendar').addClass('hide');
			}
		});
        
		$(document).keydown(function(e){
			if($('.quick-links').hasClass('open') && e.key =="Escape")
				$('.quick-links').removeClass('open');
				$('#contact_bloc, .pageBanner .ligue-calendar').removeClass('hide');
		});
        
	}

	var closeSubMenu = function(e){
		e.preventDefault();
		var item = $(e.target);
		var openedLi = item.parents("li:not(.sub-menu__back)").first();
		openedLi.removeClass('mobile-open');
		openedLi.closest('.sub-menu').removeClass('sub-open');
	}

	var initMobileMenu = function(){
		//Inject "Back" buttons in submenus
		var backButton = $("<li class='sub-menu__back'><a href='' title='Retour'>Retour</a></li>");
		backButton.on('click', closeSubMenu);
		$('.header__nav__principale .sub-menu').prepend(backButton);

		//Toggle open/close menu
		$('#toggle-nav').on('click', function(){
			if($('#toggle-search').hasClass('open')){
				$('#toggle-search, .header__nav__search').removeClass('open')
			}
			$('#toggle-nav, .header__nav__secondary, .header__nav__principale').toggleClass('open');
			$('html').toggleClass('mobile-open');
		});

		//Toggle open/close searchbar
		$('#toggle-search').on('click', function(e){
			var item = $(e.currentTarget);
			var val = $('.header__nav__search input[type="search"]').val();
			if($('#toggle-nav').hasClass('open')){
				$('#toggle-nav, .header__nav__secondary, .header__nav__principale').removeClass('open')
			}
			if(item.hasClass('open') && val && (val != "") ){
				$('.header__nav__search form').submit();
			} else {
				$('#toggle-search, .header__nav__search').toggleClass('open');
			}
		});
		
		//Open submenus
		$('.header__nav__principale .menu li.menu-item-has-children>a').on('click', function(e){
			if(window.innerWidth < 992){
				e.preventDefault();
				var item = $(e.target);
				var liItem = item.parent();
				if(!liItem.hasClass('mobile-open') && liItem.hasClass('menu-item-has-children')){
					e.preventDefault();
					liItem.addClass('mobile-open');
					liItem.closest('.sub-menu').addClass('sub-open');
				}
			}
		});
	}

	var subMenuWidth = function(){
		$('.header__nav__principale ul.menu>.menu-item-has-children').each(function(){
			var e = $(this);
			var subMenu = e.children('.sub-menu');
			var subSubMenu = subMenu.find(".sub-menu");
			if(!subSubMenu.length){
				subMenu.addClass('no-submenu');
			}
		});
	}

	var initNewsbar = function(){
		if($('.newsbar__article').length > 1){
			window.setInterval(switchNews, 5000);
		}
	}

	var switchNews = function(){
		var topVal = $('.newsbar__article:not(.active)').css('top');
		var current = $('.newsbar__article.active');
		var last = $('.newsbar__article:last-child');
		var next = (last.hasClass('active')) ? $('.newsbar__article:first-child') : current.next();
		current.animate({
			top: "-"+topVal
		}, 500, function(){
			$(this).removeClass('active').animate({
				top:topVal
			}, 0);
		});
		next.animate({
			top: "0px"
		}, 500, function(){
			$(this).addClass('active');
		});
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
